export const RESERVATION_URL = 'https://booking.reservanto.cz/Modal/?id=25060';
